import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Link, useHistory } from 'react-router-dom';
import { routes } from '@/app/routing/index';
import { getResellers } from '@/entities/admin-resellers/admin-resellers.api';
import DataGridTable from '@/common/components/DataGridTable/index';
import Filters from '@/modules/admin-resellers/components/Filters';
import { getResellersColumns } from '@/modules/admin-resellers/config';
import styles from '@/modules/admin-resellers/styles.less';
import { adminResellersQueryKeys } from '@/entities/admin-resellers';

const AdminResellersModule = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const columns = useMemo(() => getResellersColumns(t), [t]);

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h3 className={styles.pageHeaderTitle}>{t('Resellers')}</h3>
        <Button
          className={styles.pageHeaderBtn}
          variant="contained"
          color="success"
          type="button"
          component={Link}
          to={routes.adminPanel.resellerNew}
        >
          <AddIcon />
          {t('Add Reseller')}
        </Button>
      </div>
      <div className={styles.pageBody}>
        <div className={styles.tableWrap}>
          <DataGridTable
            className={styles.table}
            columns={columns}
            defaultQueryParams={{
              search: '',
              sortBy: 'name',
              sortOrder: 'ASC',
            }}
            emptyState={
              <span>
                {t('No resellers added yet.\nAdd your first reseller to get started.')}
              </span>
            }
            emptyStateClassName={styles.noList}
            queryFn={getResellers}
            queryKey={adminResellersQueryKeys.list()}
            renderFilters={({ params, updateTableParams }) => (
              <Filters
                search={params.search}
                sortBy={params.sortBy}
                sortOrder={params.sortOrder}
                onSearchChange={(search) =>
                  updateTableParams({ search }, { resetPage: true })
                }
              />
            )}
            syncSortWithQuery
            onRowClick={({ id }) =>
              history.push(`${routes.adminPanel.resellers}/${id}`)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AdminResellersModule;
